import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: number;
  title: string;
  date: string;
  author: string;
  summary: string;
  image: string;
  tags?: string[];
}

export default function ArticleCard({ id, title, date, author, summary, image, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="w-full sm:w-48 h-32 shrink-0 overflow-hidden rounded-lg">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3">{summary}</p>
        <div className="flex items-center gap-3 flex-wrap">
          <span className="text-xs text-foreground-500">{date}</span>
          <span className="text-xs text-foreground-500">{author}</span>
          {tags && tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}